import { MapPin, Mail, Phone, Zap, Pencil, Trash2, NotebookPen } from "lucide-react";
import { Link } from "react-router-dom";
import { money } from "@/lib/api";

export const ClientCard = ({ client, draft, defaultTax, onInvoice, onEdit, onDelete }) => {
  const tax = client.tax_rate ?? defaultTax;
  return (
    <div data-testid={`client-card-${client.id}`} className="surface p-4 sm:p-5 flex flex-col gap-4 fade-up hover:border-emerald-500/50 transition-colors min-w-0 overflow-hidden">
      <div className="flex items-start justify-between gap-3">
        <div className="min-w-0">
          <h3 className="text-lg font-semibold truncate">{client.name}</h3>
          {client.address && (
            <a href={`https://maps.google.com/?q=${encodeURIComponent(client.address)}`} target="_blank" rel="noreferrer"
              className="flex items-center gap-1.5 text-sm text-muted-foreground hover:text-emerald-600 mt-0.5">
              <MapPin className="h-3.5 w-3.5 shrink-0" /> <span className="truncate">{client.address}</span>
            </a>
          )}
        </div>
        <div className="flex gap-1 shrink-0">
          <button data-testid={`client-edit-button-${client.id}`} onClick={onEdit} className="h-8 w-8 grid place-items-center rounded-lg hover:bg-secondary" aria-label="Edit">
            <Pencil className="h-4 w-4" />
          </button>
          <button data-testid={`client-delete-button-${client.id}`} onClick={onDelete} className="h-8 w-8 grid place-items-center rounded-lg hover:bg-red-50 dark:hover:bg-red-950/40 text-red-600" aria-label="Delete">
            <Trash2 className="h-4 w-4" />
          </button>
        </div>
      </div>

      <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-muted-foreground min-w-0">
        {client.email && <span className="flex items-center gap-1 min-w-0 max-w-full"><Mail className="h-3 w-3 shrink-0" /><span className="truncate">{client.email}</span></span>}
        {client.phone && <span className="flex items-center gap-1"><Phone className="h-3 w-3 shrink-0" />{client.phone}</span>}
      </div>

      <div className="flex items-end justify-between gap-3 border-t border-border pt-3">
        <div className="min-w-0">
          <div className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Service</div>
          <div className="text-sm font-medium truncate">{client.service_description}</div>
        </div>
        <div className="text-right shrink-0">
          <div className="font-mono font-bold text-xl sm:text-2xl tracking-tight" data-testid={`client-amount-${client.id}`}>{money(client.default_amount)}</div>
          <div className="text-xs text-muted-foreground">+ {Number(tax)}% tax</div>
        </div>
      </div>

      {draft && (
        <Link to={`/drafts/${draft.id}`} data-testid={`client-open-draft-${client.id}`}
          className="flex items-center justify-between gap-2 rounded-lg border border-emerald-200 bg-emerald-50/70 dark:bg-emerald-950/30 dark:border-emerald-800 px-3 py-2 text-xs hover:bg-emerald-100/70 transition-colors">
          <span className="flex items-center gap-1.5 font-semibold text-emerald-700 dark:text-emerald-300"><NotebookPen className="h-3.5 w-3.5" /> Open draft · {draft.line_items.length} charge{draft.line_items.length === 1 ? "" : "s"}</span>
          <span className="font-mono font-bold">{money(draft.total)}</span>
        </Link>
      )}
      <button data-testid={`client-one-tap-invoice-button-${client.id}`} onClick={onInvoice}
        className="zap-btn h-12 rounded-lg flex items-center justify-center gap-2 text-sm uppercase tracking-wide">
        <Zap className="h-4 w-4" fill="currentColor" /> {draft ? "Add Today's Charge" : "Send Invoice Now"}
      </button>
    </div>
  );
};
